import { createContext, useContext } from 'react';
import { HtsObject } from 'types';

type OptionalHTS = HtsObject | undefined;
export interface HtsValues {
  lineHtsNumber?: string;
  htsObjects: OptionalHTS[];
  htsNumbers: (string | undefined)[];
  licenseCode?: string;
  lineHTSObj: OptionalHTS;
}

export const defaultContext = {
  htsValues: {
    htsNumbers: [],
    lineHTSObj: undefined,
    htsObjects: [],
  },
  queryLoading: false,
};

export interface HtsValuesContextProps {
  htsValues: HtsValues;
  queryLoading: boolean;
}

export const htsValuesContext =
  createContext<HtsValuesContextProps>(defaultContext);

export const useHtsValues = (): HtsValuesContextProps =>
  useContext(htsValuesContext);

export const getHtsObjectByIndex = (
  htsValues: HtsValues,
  index: number,
): OptionalHTS => {
  return htsValues.htsObjects[index];
};
